import { HotSpring } from '@travel/icons/service';
import cx from '@travel/ui/utils/classnames';

import styles from './hotSpringLabel.module.scss';

type Props = {
  className?: string;
};

const HotSpringLabel = ({ className = '' }: Props) => {
  return (
    <div className={cx(styles.hotSpringLabel, className)}>
      <HotSpring size={14} className={styles.hotSpringIcon} />
      <span className={styles.hotSpringText}>温泉宿</span>
    </div>
  );
};

export default HotSpringLabel;
